import { z } from 'zod';
import { msObject } from '../resource-base/msObject';
import { ApplicationAuthenticationProviderType } from '../enumerations/applicationAuthenticationProviderType';

const MaestraSignalApplicationInformationPayloadSchemaBase = msObject({
    applicationVersion: z.string(),
    authenticationProvider: z.enum(ApplicationAuthenticationProviderType),
    oidcAuthenticationProviderIssuerURI: z.string().url().optional(),
    oidcAuthenticationProviderFrontendClientId: z.string().optional(),
});

const OIDCMaestraSignalApplicationInformationPayloadSchema =
    MaestraSignalApplicationInformationPayloadSchemaBase.extend({
        authenticationProvider: z.literal(ApplicationAuthenticationProviderType.OIDC),
        oidcAuthenticationProviderIssuerURI: z.string().url(),
        oidcAuthenticationProviderFrontendClientId: z.string(),
    });

const EmbeddedMaestraSignalApplicationInformationPayloadSchema =
    MaestraSignalApplicationInformationPayloadSchemaBase.extend({
        authenticationProvider: z.literal(ApplicationAuthenticationProviderType.EMBEDDED),
        jwtAccessTokenValidityInSeconds: z.number(), // TODO remove
        jwtRefreshTokenValidityInSeconds: z.number(), // TODO remove
    });

const NotConfiguredMaestraSignalApplicationInformationPayloadSchema =
    MaestraSignalApplicationInformationPayloadSchemaBase.extend({
        authenticationProvider: z.literal(ApplicationAuthenticationProviderType.NOT_CONFIGURED),
    });

export const MaestraSignalApplicationInformationPayloadSchema = z.discriminatedUnion('authenticationProvider', [
    OIDCMaestraSignalApplicationInformationPayloadSchema,
    EmbeddedMaestraSignalApplicationInformationPayloadSchema,
    NotConfiguredMaestraSignalApplicationInformationPayloadSchema,
]);

export type MaestraSignalApplicationInformationPayload = z.infer<
    typeof MaestraSignalApplicationInformationPayloadSchema
>;
